export const SET_PRACTICE = 'SET_PRACTICE';
export const SET_PRACTICES = 'SET_PRACTICES';
export const SET_PRACTICES_QUERY_PARAMS = 'SET_PRACTICES_QUERY_PARAMS';
export const SET_PRACTICES_SET_IS_FETCHING = 'SET_PRACTICES_SET_IS_FETCHING';
